/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .controller('FileUploadModalController', [
        '$modalInstance',
        '$q',
        '$scope',
        '$timeout',
        'FILE_DROP_EVENT',
        'FileUploadModal',
        'IS_INTERNET_EXPLORER',
        'operationComplete',
        'Uploader',
        'UPLOADER_EVENT',
        function (
            $modalInstance,
            $q,
            $scope,
            $timeout,
            FILE_DROP_EVENT,
            FileUploadModal,
            IS_INTERNET_EXPLORER,
            operationComplete,
            Uploader,
            UPLOADER_EVENT
        ) {
            var AUTO_CLOSE_DELAY_IN_MILLISECONDS = 800;

            $scope.modal = $modalInstance.options;

            Object.defineProperties($scope, {
                isIE: {
                    value: IS_INTERNET_EXPLORER
                },
                uploadQueue: {
                    get: function () {
                        return Uploader.queue;
                    }
                },
                isUploadQueueEmpty: {
                    get: function () {
                        return Uploader.queue.length === 0;
                    }
                },
                isUploadQueueFull: {
                    get: function () {
                        return Uploader.isQueueFull;
                    }
                },
                isUploadQueueHasFile: {
                    get: function () {
                        for (var i = 0, item = Uploader.queue[i]; i < Uploader.queue.length; item = Uploader.queue[++i]) {
                            if (!item.isDirectory) {
                                return true;
                            }
                        }

                        return false;
                    }
                },
                hasNewUploadItems: {
                    get: function () {
                        return Uploader.newUploadItems.length > 0;
                    }
                },
                isUploading: {
                    get: function () {
                        return Uploader.isUploading;
                    }
                }
            });

            $scope.removeFromQueue = function (item) {
                Uploader.removeFromQueue(item);
            };

            $scope.uploadAll = function () {
                Uploader.upload($scope.folder);
            };

            $scope.removeItem = function (item) {
                Uploader.removeFromQueue(item);
            };

            $scope.close = function () {
                Uploader.cancelUpload();

                $modalInstance.close(Uploader.stat);
            };

            $scope.overwrite = function (uploadItem) {
                Uploader.overwriteAndUpload($scope.folder, uploadItem);
            };

            $scope.overwriteAll = function () {
                Uploader.overwriteAndUpload($scope.folder);
            };

            $scope.chooseFilesHandler = function (event) {
                Uploader.addToQueue(event.target.files, false);
                event.target.value = '';
            };

            Uploader.on(UPLOADER_EVENT.QUEUE_UPDATED, _onUploadQueueUpdate);
            Uploader.on(UPLOADER_EVENT.UPLOAD_START, _onUploadStart);
            Uploader.on(UPLOADER_EVENT.UPLOAD_END, _onUploadEnd);
            Uploader.on(UPLOADER_EVENT.ITEM_UPLOAD_UPDATE, _onItemUploadUpdate);
            Uploader.on(UPLOADER_EVENT.ITEM_UPLOAD_START, _onItemUploadStart)

            $scope.$on('$destroy', function () {
                Uploader.off(UPLOADER_EVENT.QUEUE_UPDATED, _onUploadQueueUpdate);
                Uploader.off(UPLOADER_EVENT.UPLOAD_START, _onUploadStart);
                Uploader.off(UPLOADER_EVENT.UPLOAD_END, _onUploadEnd);
                Uploader.off(UPLOADER_EVENT.ITEM_UPLOAD_UPDATE, _onItemUploadUpdate);
                Uploader.off(UPLOADER_EVENT.ITEM_UPLOAD_START, _onItemUploadStart);
                Uploader.clearQueue();
            });

            $scope.$on(FILE_DROP_EVENT.DROPPED, _onFilesDropHandler);

            _resolveFolder($scope.folder);

            function _onUploadQueueUpdate() {
                _safeDigest();
            }

            function _onUploadStart() {
                $scope.modal.loading = true;
            }

            function _onUploadEnd() {
                $scope.modal.loading = false;

                var uploadStat = Uploader.stat;

                // We prevent modal closing if any of uploads are failed or has conflicts
                if (
                    uploadStat.error > 0 ||
                    uploadStat.conflict > 0
                ) {
                    return;
                }

                $timeout(function () {
                    if (uploadStat.success > 0) {
                        operationComplete(
                            'file_upload_success_message',
                            {
                                COUNT: uploadStat.success,
                                items_count: uploadStat.success
                            },
                            'messageformat'
                        );
                    }
                    $modalInstance.close(uploadStat);
                }, AUTO_CLOSE_DELAY_IN_MILLISECONDS);
            }

            function _onItemUploadStart() {
                _safeDigest();
            }

            function _onItemUploadUpdate() {
                _safeDigest();
            }

            function _safeDigest() {
                if (!$scope.$root.$$phase) {
                    $scope.$digest();
                };
            }

            /**
             * Resolve target folder and populate it with additional fields
             *
             * @param {Resource} folder - Target folder
             * @return {Promise}
             */
            function _resolveFolder(folder) {
                if (angular.isDefined(folder.parents)) {
                    return $q.resolve(folder);
                } else {
                    $scope.modal.loading = true;

                    folder.constructor.get({ uuid: folder.uuid }).$promise
                        .then(function (resolvedFolder) {
                            folder.parents = resolvedFolder.parents;
                        })
                        .finally(function () {
                            $scope.modal.loading = false;
                        });
                }
            }

            function _onFilesDropHandler(_, target, dataTransfer) {
                FileUploadModal(target, dataTransfer);
            }
        }]);
